import {FormikErrors} from 'formik';
import {set} from 'lodash-es';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {transferSourceType} from './builderTransferFields';

export const transferValidator = (
  values: builderFieldsType,
  errors: FormikErrors<builderFieldsType>
): FormikErrors<builderFieldsType> => {
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const transferValues = values.transfer;
  if (!transferValues) {
    errors.transfer = 'Please fill in transfer fields';
    return errors;
  }
  if (
    !transferValues.transferSources ||
    Object.values(transferValues.transferSources).length === 0
  ) {
    set(errors, 'transfer.transferSources', 'Please select at least one account');
  } else {
    Object.values(transferValues.transferSources).forEach((source) => {
      // shell-plan-only validation (new sources): plan number, plan type, provider, value,
      // contact, and the isDataGather/isAuthorityHeld pair.
      if (source.isShellPlan || source.id.includes('shell')) {
        transferShellValidator(source, values.isSppDa, errors);
      }
      // initial-fee validation — runs for every source regardless of shell/existing
      if (!values.isLisa) {
        if (values.isSppDa) {
          if (!source.legacyInitialFee?.feeType) {
            set(
              errors,
              `transfer.transferSources.${source.id}.legacyInitialFee.feeType`,
              'Required'
            );
          }
          if (
            source.legacyInitialFee?.feeType === '%' &&
            source.legacyInitialFee.percentageFee === undefined
          ) {
            set(
              errors,
              `transfer.transferSources.${source.id}.legacyInitialFee.percentageFee`,
              'Required'
            );
          }
          if (
            source.legacyInitialFee?.feeType === 'GBP' &&
            source.legacyInitialFee.fixedFee === undefined
          ) {
            set(
              errors,
              `transfer.transferSources.${source.id}.legacyInitialFee.fixedFee`,
              'Required'
            );
          }
        } else if (!source.initialFee) {
          set(errors, `transfer.transferSources.${source.id}.initialFee`, 'Required');
        }
      }
    });
  }

  if (!transferValues.destinationValues?.existingPotId) {
    set(errors, 'transfer.destinationValues.existingPotId', 'Please select an account');
  }

  return errors;
};

const transferShellValidator = (
  source: transferSourceType,
  isSppDa: boolean,
  errors: FormikErrors<builderFieldsType>
): FormikErrors<builderFieldsType> => {
  const key = `transfer.transferSources.${source.id}`;
  if (!source.accountNumber) {
    set(errors, `${key}.accountNumber`, 'Required');
  }
  if (!source.planProvider) {
    set(errors, `${key}.planProvider`, 'Required');
  }
  if (!source.planType) {
    set(errors, `${key}.planType`, 'Required');
  }
  if (!source.planValue) {
    set(errors, `${key}.planValue`, 'Required');
  }
  if (!source.full && !source.singleClientAmount) {
    set(errors, `${key}.singleClientAmount`, 'Required');
  }
  if (!source.contactId) {
    set(errors, `${key}.contactId`, 'Required');
  }
  // isDataGather / isAuthorityHeld — tri-state string ('yes' | 'no' | '')
  // Required on shell plans only (existing sources read these from the pot).
  if (!isSppDa) {
    if (source.isDataGather) {
      if (source.isDataGather === 'yes' && !source.isAuthorityHeld) {
        set(errors, `${key}.isAuthorityHeld`, 'Required');
      }
    } else {
      set(errors, `${key}.isDataGather`, 'Required');
    }
  }
  return errors;
};
